import React, { useEffect } from 'react'
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  User,
  UserCredential,
} from 'firebase/auth'
import { createContext, useState } from 'react'
import { firebaseAuth } from 'src/utils/firebase'

interface FirebaseSession {
  loginUser: (email: string, password: string) => Promise<UserCredential>
  user: User | null | boolean
  isSignedIn: boolean
}

export const FirebaseContext = createContext<FirebaseSession | undefined>(undefined)

function FirebaseProvider({ children }: { children: React.ReactElement }) {
  const [user, setUser] = useState<User | null | false>(false)

  const isSignedIn = Boolean(user)

  const loginUser = (email: string, password: string) =>
    signInWithEmailAndPassword(firebaseAuth, email, password)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebaseAuth, user => {
      if (user) {
        setUser(user)
        // loggedIn
      } else {
        setUser(null)
        // no valid
      }
    })

    return () => unsubscribe()
  }, [])

  return (
    <FirebaseContext.Provider value={{ loginUser, user, isSignedIn }}>
      {children}
    </FirebaseContext.Provider>
  )
}

export default FirebaseProvider
